import PropTypes from "prop-types";

import { ButtonGroup } from "@transfr-inc/dashboard-components/forms";

import { Loader } from "@features/ui";
import { BudgetCategoryView } from "../components";

import { currencyFormat } from "@lib/text.helpers";
import { useUpdateBudgetPlan } from "../api";

import "./housing-budget.scss";

export const HousingBudget = ({
  budgetCategoryCode,
  budgetPlan,
  selected,
  onChoiceChange,
}) => {
  const { mutate: updateBudgetPlan, isPending: isUpdatingBudgetPlan } =
    useUpdateBudgetPlan(budgetPlan?.id);

  const handleLivingAloneChange = (value) => {
    updateBudgetPlan({ is_living_alone: value });
  };

  const getOptionAmount = (option) => {
    return option.amount / (budgetPlan?.isLivingAlone ? 1 : 2);
  };

  const renderOptionContent = (option) => (
    <>
      {option.label} ({currencyFormat(getOptionAmount(option))})
    </>
  );

  return (
    <>
      <BudgetCategoryView
        className="housing-budget-view"
        budgetCategoryCode={budgetCategoryCode}
        selected={selected}
        onChoiceChange={onChoiceChange}
        getOptionAmount={getOptionAmount}
        renderOptionContent={renderOptionContent}
      >
        <BudgetCategoryView.Prelude>
          <div className="housing-budget-roommate-toggle">
            <ButtonGroup
              role="radiogroup"
              buttons={[
                {
                  label: "I'll Live Alone",
                  value: "alone",
                  id: 1,
                  props: {
                    role: "radio",
                    "aria-label": "I'll live alone",
                  },
                  onClick: () => handleLivingAloneChange(true),
                },
                {
                  label: "With a Roommate",
                  value: "with-roommate",
                  id: 2,
                  props: {
                    role: "radio",
                    "aria-label": "With a roommate",
                  },
                  onClick: () => handleLivingAloneChange(false),
                },
              ]}
              selected={budgetPlan?.isLivingAlone ? 1 : 2}
            />
          </div>
        </BudgetCategoryView.Prelude>
      </BudgetCategoryView>
      <Loader show={isUpdatingBudgetPlan} text="saving..." />
    </>
  );
};

HousingBudget.propTypes = {
  budgetCategoryCode: PropTypes.string.isRequired,
  budgetPlan: PropTypes.shape({
    id: PropTypes.number,
    isLivingAlone: PropTypes.bool,
  }),
  selected: PropTypes.shape({
    id: PropTypes.number,
  }),
  onChoiceChange: PropTypes.func,
};
